import { Theme } from '@mui/material/styles';

import Input from './Input';

function overrideComponents(theme: Theme) {
    return Object.assign(Input(theme));
}

export { overrideComponents };
